import { InspectionReportDetail, InspectionReportsResponse } from '../types'

/** TYPES **/
export const inspectionReportsTypes = {
  FETCH_INSPECTION_REPORTS: 'FETCH_INSPECTION_REPORTS',
  SET_INSPECTION_REPORTS: 'SET_INSPECTION_REPORTS',
  FETCH_INSPECTION_REPORT_BY_ID: 'FETCH_INSPECTION_REPORT_BY_ID',
  SET_INSPECTION_REPORT_BY_ID: 'SET_INSPECTION_REPORT_BY_ID',
  CREATE_INSPECTION_REPORT: 'CREATE_INSPECTION_REPORT',
}

/** ACTIONS **/
export interface FetchInspectionReportsAction {
  type: typeof inspectionReportsTypes.FETCH_INSPECTION_REPORTS
  payload: {
    limit: number,
    page: number,
    start: number,
  }
  callback?: (succ: boolean) => void
}

export interface FetchInspectionReportByIdAction {
  type: typeof inspectionReportsTypes.FETCH_INSPECTION_REPORT_BY_ID
  payload: string
  callback?: (succ: boolean) => void
}


export interface SetInspectionReportsAction {
  type: typeof inspectionReportsTypes.SET_INSPECTION_REPORTS
  payload: InspectionReportsResponse | null
}

export interface SetInspectionReportByIdAction {
  type: typeof inspectionReportsTypes.SET_INSPECTION_REPORT_BY_ID
  payload: InspectionReportDetail | null
}

export interface CreateInspectionReportAction {
  type: typeof inspectionReportsTypes.CREATE_INSPECTION_REPORT
  payload: {
    estimateId: string,
    fileUrl: string,
  }
  callback?: (succ: boolean) => void
}

export type InspectionReportsActions =
  | FetchInspectionReportsAction
  | SetInspectionReportsAction
  | FetchInspectionReportByIdAction
  | SetInspectionReportByIdAction
  | CreateInspectionReportAction
/** REDUCER **/
export type InspectionReportsType = {
  inspectionReports: InspectionReportsResponse | null,
  inspectionReportData: InspectionReportDetail | null,
}
